import { Grid } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import { styled } from '@mui/material/styles';
import { breakpoints } from '../../../theme';

export const Bar = styled(AppBar)`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primary.main};
  box-shadow: none;
  color: ${({ theme }) => theme.colors.neutral.shades.shade500};
  min-height: 60px;
`;

export const Container = styled(Grid)`
  max-width: 1216px;
  margin: 0 auto;
  width: 100%;
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  ${({ theme }) => theme.breakpoints.down(breakpoints.desktop)} {
    padding: 0 24px;
  }
`;
export const Menu = styled(Grid)`
  background-color: ${({ theme }) => theme.colors.neutral.shades.shade200};
  padding-top: ${({ theme }) => theme.spacing(2)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  margin-left: ${({ theme }) => `-${theme.spacing(2)}px`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
